import PropTypes from "prop-types";
import React from "react";

export default function Newsletter({ block }) {
  const blockData = block.getData();

  const callText = blockData.get("callText");
  const buttonText = blockData.get("buttonText");

  return (
    <div
      css={{
        borderRadius: 4,
        overflow: "hidden",
        marginTop: 10,
        display: "grid",
        gridRowGap: 12,
        textAlign: "center",
      }}
    >
      <p
        css={{
          width: "100%",
          fontWeight: 500,
          fontSize: 14,
          lineHeight: 1.33,
        }}
      >
        {callText}
      </p>

      <div>
        <button
          data-intercom-target="SubscribeForNewsletter"
          type="button"
          css={{
            margin: 0,
            padding: 12,
            color: "white",
            fontSize: 14,
            letterSpacing: 0.6,
            backgroundColor: "#63cc99",
            border: "none",
            borderRadius: 4,
            width: 210,
          }}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
}

Newsletter.propTypes = {
  block: PropTypes.object.isRequired,
};
